import React from 'react';
import PropTypes from 'prop-types';

import { ButtonsWrapper, Button, Flex } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const QuoteSOVButton = ({
  isFormValidated,
  onDownloadClick,
  onProceedClick,
  onValidateForm
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: { DOWNLOAD_THE_QUOTE, PROCEED_WITH_THE_ORDER, continueButton }
  } = localizedStringsContext;

  return (
    <ButtonsWrapper>
      <Flex>
        {isFormValidated && (
          <>
            <Button>
              <button
                type="button"
                onClick={e => onDownloadClick(e)}
                className="frg-button color-green"
              >
                <span>{DOWNLOAD_THE_QUOTE}</span>
              </button>
            </Button>
            <Button>
              <button
                type="button"
                onClick={e => onProceedClick(e)}
                className="frg-button color-purple"
              >
                <span>{PROCEED_WITH_THE_ORDER}</span>
              </button>
            </Button>
          </>
        )}

        {!isFormValidated && (
          <Button>
            <button
              type="button"
              onClick={e => onValidateForm(e)}
              className="frg-button color-purple"
            >
              <span>{continueButton}</span>
            </button>
          </Button>
        )}
      </Flex>
    </ButtonsWrapper>
  );
};

QuoteSOVButton.propTypes = {
  isFormValidated: PropTypes.bool.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired
};

export default QuoteSOVButton;
